var React = require('react');

function Lines (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeWidth":"3"},[React.createElement("path",{"d":"M16.584 11h15","data-name":"Line 25","key":0}),React.createElement("path",{"d":"M1.5 1.5h30.084","data-name":"Line 24","key":1}),React.createElement("path",{"d":"M1.5 20.5h30.084","data-name":"Line 26","key":2})]));
}

Lines.defaultProps = {"width":"33.084","height":"22"};

module.exports = Lines;

Lines.default = Lines;
